
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/contacts",
      function () {
        return require("private-next-pages/android/local/contacts/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/contacts"])
      });
    }
  